import { Link } from "gatsby"
import React from "react"
import Link_arrow from "../../components/svg/Link_arrow"
import LinkButtonRed from "../buttons/linkButtonRed/linkButtonRed"
import * as style from "./webinarService.module.css"

const WebinarService = ({
  embraceItTitle,
  embraceItDescription,
  embraceItButtonText,
  embraceItSectionLeftImage,
  embraceItSectionLeftTitle,
  embraceItSectionLeftSubtitleTag,
  insightsDescription,
  insightsLink,
  insightsTitle,
  projectsTitle,
  projectsLink,
  comingSoonWebinar,
  projectsDesctiption,
  youtubeLink,
}) => {
  return (
    <section className={style.service_section}>
      <div className="container">
        <div className={style.service_wrapper}>
          <div>
            <div className={style.mix_heading}>
              <h2>{embraceItTitle}</h2>
              <p>{embraceItDescription}</p>
            </div>
          </div>
          <div className={style.bottom_wrapper}>
            {comingSoonWebinar == "yes" ? (
              <div
                className={style.left_box}
                style={{
                  backgroundImage: `url(${embraceItSectionLeftImage?.mediaItemUrl})`,
                }}
              >
                <div className={style.text_box}>
                  <span> {embraceItSectionLeftSubtitleTag} </span>
                  <h3>{embraceItSectionLeftTitle}</h3>
                  <LinkButtonRed
                    btnText={embraceItButtonText}
                    linkTo="https://www.agileinfoways.com/"
                    CustomBtnClass="btn-view-services m-0"
                    target={"_blank"}
                  />
                </div>
              </div>
            ) : (
              <div className={style.left_box}>
                <iframe
                  style={{ width: "100%", height: "100%" }}
                  src={youtubeLink}
                  name="page"
                  title="YouTube video player"
                  allowFullScreen
                ></iframe>
              </div>
            )}

            <div className={style.right_box}>
              <div className={`${style.div_box} ${style.red}`}>
                <p> {insightsDescription} </p>
                <div className={style.link_btn}>
                  <span> {insightsTitle} </span>
                  <Link
                    target={"_blank"}
                    to="https://www.agileinfoways.com/blogs/"
                  >
                    <Link_arrow />
                  </Link>
                </div>
              </div>
              <div className={`${style.div_box} ${style.black}`}>
                <p>{projectsDesctiption}</p>
                <div className={style.link_btn}>
                  <span> {projectsTitle} </span>
                  <Link
                    target={"_blank"}
                    to="https://www.agileinfoways.com/case-studies/"
                  >
                    <Link_arrow />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WebinarService
